export default "<p>general works!</p>\n"